import { render, staticRenderFns } from "./ReuneConsultasForm.vue?vue&type=template&id=7bbf22d4&"
import script from "./ReuneConsultasForm.vue?vue&type=script&lang=js&"
export * from "./ReuneConsultasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports